import config from '../../config';
import { getFromApi } from 'actions';

export default resourcePath =>
  getFromApi(`${config.walletService.baseUrl}${resourcePath}`);
